import { Mic } from "lucide-react"
import { useRef } from "react"
import { useMicLevel } from "@/hooks/use-mic-level"
import { cn } from "@/lib/utils"

type MicFillIconProps = {
  stream: MediaStream | null
  className?: string
}

/** Микрофон, залитый снизу вверх по уровню громкости потока (`--mic-fill`). */
export function MicFillIcon({ stream, className }: MicFillIconProps) {
  const fillRef = useRef<HTMLSpanElement>(null)
  useMicLevel(stream, fillRef)

  return (
    <span ref={fillRef} aria-hidden className={cn("relative inline-flex h-4 w-4 [--mic-fill:0]", className)}>
      <Mic className="h-full w-full opacity-40" />
      <span className="absolute inset-0 [clip-path:inset(calc((1-var(--mic-fill))*100%)_0_0_0)]">
        <Mic className="h-full w-full" />
      </span>
    </span>
  )
}
